export const Sections = Object.freeze({
  GENERAL_ACCOUNT: { id: "general_account" },
  GENERAL_SUBSCRIPTION: { id: "general_subscription" },
  GENERAL_INBOX: { id: "general_inbox" },
  GAMES_OVERVIEW: { id: "games_overview" },
  GAMES_ADD_NEW: { id: "games_addnew" },
  GAMES_ADD_NEW_DETAILS: { id: "games_add_new_details" },
  GAMES_SETTINGS: { id: "games_settings" },
  APPS_OVERVIEW: { id: "apps_overview" },
  APPS_ADD_NEW: { id: "apps_addnew" },
  APPS_DETAILS: { id: "apps_details" }
});